import { t } from '@lingui/core/macro';

import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';

import OfflineActivityTableContainer from './OfflineActivityTableContainer';
import VendorActivityKPIs from './VendorActivityKPIs';
import VendorActivityTableContainer from './VendorActivityTableContainer';
import VendorFitScoringTable from './VendorFitScoringTable';
import VendorOverviewActions from './VendorOverviewActions';

const DEFAULT_QUERY_STATE: Partial<QueryState> = {
  size: 100,
  sortBy: 'visits',
  sortOrder: InstantSearchSortOrder.DESC,
};

const IGNORED_FIELDS = ['filters', 'page', 'size'] as (keyof QueryState)[];

const OFFLINE_EVENTS_DEFAULT_QUERY_STATE: Partial<QueryState> = {
  sortBy: 'visits',
  sortOrder: InstantSearchSortOrder.DESC,
};

const OFFLINE_EVENTS_IGNORED_FIELDS = ['filters', 'page', 'size'] as (keyof QueryState)[];

const VendorOverview = () => {
  return (
    <Page
      title={t`Vendors`}
      pageName={t`All Vendors`}
      exampleAIQuestions={exampleAIQuestions('vendor')}
    >
      <InstantSearch
        prefix="v"
        defaultQueryState={DEFAULT_QUERY_STATE}
        ignoredFields={IGNORED_FIELDS}
      >
        <PageFilterProvider>
          <div className="flex w-full flex-col gap-6">
            <div className="flex justify-between">
              <PageDateRangeFilter />
              <VendorOverviewActions />
            </div>
            <VendorActivityKPIs />
            <VendorActivityTableContainer />
            <InstantSearch
              prefix="o"
              defaultQueryState={OFFLINE_EVENTS_DEFAULT_QUERY_STATE}
              ignoredFields={OFFLINE_EVENTS_IGNORED_FIELDS}
            >
              <OfflineActivityTableContainer />
            </InstantSearch>
            <VendorFitScoringTable />
          </div>
        </PageFilterProvider>
      </InstantSearch>
    </Page>
  );
};

export default VendorOverview;
